// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rgRHFH_jrzJtma {
  margin-top: 34px;
}
.rgRHFH_jrzJtma table tr td {
  border: 1px solid var(--ds-border, #091e4224);
}
.rgRHFH_jrzJtma table tbody tr td:nth-child(4) {
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.rgRHFH_jrzJtma table tbody tr:last-child td:nth-last-child(2) {
  border-bottom: 3px solid var(--ds-border-discovery, #8270db);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `rgRHFH_jrzJtma`
};
export default ___CSS_LOADER_EXPORT___;
